export const normalizeBrandTitle = (value: string) => (
  String(value || '').replace(/\bKundlistar\b(?!\s+Studio)/gi, 'Kundlistar Studio')
);
